import { Box } from "@mui/material";
import type { BannerOverlayProps } from "./types/BannerOverlayProps";

export function BannerOverlay({ color = "#000000ce" }: BannerOverlayProps) {
  return <Box sx={{ position: "absolute", backgroundColor: color, height: "100%", width: "100%" }} />;
}
